import { ICarouselItem } from "../components/shared/custom-carousel/custom-carousel.component";

export class Proyecto {
  idProyecto?: number = -1;
  idLanding?: number = -1;
  idUsuario?: number = -1;
  idProspecto?: Number = -1;
  idEmpresaAfiliada?: number = -1;
  idsEmpresasAfiliadas?: string = "";
  idSeguimientoProspecto?: number = -1;
  idRegion?: number = -1;
  nombre?: string = "";
  nombreEmpresa?: string = "";
  estatus?: string = "";
  idModelo?: number = -1;
  idEvento?: number = -1;
  idCierre?: number = -1;
  idCiudad?: number = -1;
  idAsignacion?: number = -1;
  inventario?: number = -1;
  seleccionado?: number = -1;
  minimo?: number = 0;
  maximo?: number = 99999999.9;
  latitud?: number = 0;
  longitud?: number = 0;
  direccion?: string = "";
  descripcion?: string = "";
  // Campos extendidos de descripción
  necesidadResuelve?: string = "";
  comoAyudas?: string = "";
  porQueEsEspecial?: string = "";
  tipo?: Number = 0;
  lotesDisponibles?: number = -1;
  numeroLotes?: number = -1;
  logo?: File;
  //ComisionProyecto?:ComisionProyecto
  fechaHoraUM?: Date;
  idUsuarioUM?: number = -1;
  nombreConjunto?: string = "";
  galeria?: ICarouselItem[] = [];
  precioString?: string = "";
  metrosString?: string = "";
  idsProyectos?: string = "";
  seleccionadoOtro?: number = 0;
  fechaFinProyecto?: Date = new Date();
  engancheMinimoApartado?: number = 0;
  rendimientoAnual?: number = 0;
  checkeadodd?: boolean = false;
  mesesDeEntrega?: number = 0;
  tipoImagen?: string = '';

  //----------------
  idLote?: number = 0;
  unidadVentas?: number = 0;
  unidadesMaximas?: number = 0;
  listaActual?: number = 0;
  cantidadGaleria?: number = 0;
  lista_precios_activas_simulado?: string = "";
  unidadesRestantes?: number = 0;
  asistioCita?: boolean = false;
  urlUbicacion?: string = "";
  accesoBackOffice?: number = 0;
  tipoVenta?: number = -1;
  tipoProyecto?: number = -1;
  fechaInicio?: Date;
  fechaFin?: Date;

  conjuntoProyecto?: number = -1;
  movil?: number = 0;
  telefono?: string = "";
  lada?: string = "";
  tipoDivisa?: string = "";
  tipoDivisaValor?: string = "";

  //Para la tienda origen
  calle?: string = "";
  numero?: number = 0;
  colonia?: string = "";
  codigoPostal?: number = 0;
  direccionCompleta?: number = 0;

  //Para el selector de proyectos generico
  idBodyPerson?: number = -1;

  editarDescripcion?: boolean = false;
  tiendaActiva?: number = 0;
  tiendaCompleta?: number = 0;
  urlTienda?: string = "";
}

export class RecuperaProyectosDTO {
  idEmpresaAfiliada?: number = -1;
  idUsuario?: number = -1;
  idProyecto?: number = -1;
  estatus?: string = "";
  tipo?: number = -1;
}

export class TourConfiguracion {
  descripcionUsuarioInmobiliario?: string = "";
  tituloMarketingInmobiliario?: string = "";
  descripcionMarketingInmobiliario?: string = "";
  tituloTourMarketingBusiness?: string = "";
  descripcionTourMarketingBusiness?: string = "";
}

export class ProyectoDirecciones {
  idProyecto?: number = 0;
  colonia?: string = "";
  calle?: string = "";
  numero?: number = 0;
  codigoPostal?: number = 0;
}

export class ProyectoLineaDto {
  idProyecto?: number = 0;
  idLinea?: number = 0;
  idUsuarioUM?: number = 0;
  nombre?: string = "";
  descripcion?: string = "";
  estatus?: string = "";
  idEmpresaAfiliada?: number = 0;
  idAutomatizacion?: number = 0;
  descripcionProyecto?: string = "";
}


export class ProyectoReglaComision {
  idReglaBase?: number = 0;
  idProyecto?: number = 0;
  nombre?: string = "";
  descripcion?: string = "";
  tipoDato?: string = "";
  idUsuarioUM?: number = 0;
  estado?: string = "";
  mensaje?: string = "";
}

export class CondicionCombinacionDto {
  idReglaBase?: number = 0;
  operador?: string = "";
  valor?: string = "";
}

export class CombinacionComisionDto {
  idProyecto?: number = 0;
  nombre?: string = "";
  porcentajeComision?: number = 0;
  condiciones?: CondicionCombinacionDto[] = [];
}

export class ResultadoCombinacion {
  estado?: string = "";
  mensaje?: string = "";
  idCombinacion?: number | null = null;
}

export class FilaMatrizCombinacionDto {
  regla?: string = "";
  tipoDato?: string = "";
  combinacion: string;
  valores: { [key: string]: string }; // valores por regla

}

export class PeriodoValidezDto {
  idProyecto: number = 0;
  diasAntes: number = 0;
  diasDespues: number = 0;
  idUsuarioUM: number = 0;
}


export class Proyecto_Reserva_Horarios {
  idHorario?: number = 0;
  idProyecto?: number = 0;
  diaSemana?: string = "";
  horaInicio?: string = "";
  horaFin?: string = "";
  fechaHoraUM?: Date = new Date();
  idUsuarioUM?: number = 0;
  horaInicioString?: string = "";
  horaFinString?: string = "";
  saltoDeHoraString?: string = "";
  saltoDeHora?: number = 0;
  saltoDeMinutos?: number = 0;

}

export class ProyectoReservaReglaDTO {
  idRegla: number = 0;
  idProyecto: number = 0;
  tipoModalidad: number = 0;
  cantidad: number = 0;
  descuento: number;
  fechaHoraUM: string;
  idUsuarioUM: number;
  idLote: number;
  descripcionReglas: string;
  totalCosto: number = 0;
}